module.exports = __webpack_public_path__ + "img/item_Story_23.ac4d79ee.jpeg";